module.exports = __webpack_public_path__ + "static/media/subOutlook2.d7190f8c.png";